/**
 * The door to the public Try it (rebel Ai's editor in a public mode, served by the app at try.leadpops.com in the LeadPops skin).
 * Built once in the app (rebelcalcv2 docs/rebel-sites/directives/TRY-IT-PUBLIC-2026-10-21.md); this site only links to it.
 *
 * OFF until the app's public try route is live and try.leadpops.com answers (the REBEL SITES director says when). Switching it on
 * is `enabled: true` here: the header and the phone menu then show the link. Nothing else on the site changes, and the demo
 * request buttons stay exactly as they are.
 */
export const TRY_IT = {
  enabled: false,
  url: 'https://try.leadpops.com',
  label: 'Try it free',
} as const;

/** The Try it address carrying the visitor's look, so they land in the same light or dark mode they were reading in. */
export function tryItHref(mode: string | null | undefined): string {
  return `${TRY_IT.url}/?look=${mode === 'light' ? 'light' : 'dark'}`;
}
